import { HorizontalAlignment, StringUtil } from "@mcleod/core";
import { Component } from "../../base/Component";
import { Image } from "../../components/image/Image";
import { ImageType } from "../../components/image/ImageType";
import { Label } from "../../components/label/Label";
import { Panel } from "../../components/panel/Panel";
import { PanelProps } from "../../components/panel/PanelProps";
import { Spinner } from "../../components/spinner/Spinner";

export class ReportViewer extends Panel {
    private labelPlaceholder: Label;
    private spinnerBusy: Spinner;
    private imagePreview: Image;
    private _searching: boolean = false;

    constructor(panelProps?: Partial<PanelProps>) {
        super({
            id: "panelReportViewer",
            fillRow: true,
            fillHeight: true,
            padding: 8,
            ...panelProps
        });
        this.createPlaceholderLabel();
        this.createBusySpinner();
        this.createPreviewImage();
        this.add(this.labelPlaceholder);
    }

    public clear() {
        this.imageBytes = undefined;
    }

    public set imageBytes(value: string) {
        this.imagePreview.imageBytes = (value == null) ? "" : value;
        if (StringUtil.isEmptyString(this.imagePreview.imageBytes) === true)
            this.labelPlaceholder.text = "Report Preview Is Not Available";
        this.sync();
    }

    public get searching(): boolean {
        return this._searching;
    }

    public set searching(value: boolean) {
        this._searching = value ?? false;
        this.sync();
    }

    private createPlaceholderLabel() {
        this.labelPlaceholder = new Label({
            id: "labelPreview",
            text: "Report Preview Will Appear Here",
            align: HorizontalAlignment.CENTER,
            backgroundColor: "backgroundSubtle",
            color: "subtle.darker",
            fillHeight: true,
            fillRow: true,
            fontSize: "xlarge",
            padding: 0
        });
    }

    private createBusySpinner() {
        this.spinnerBusy = new Spinner();
        this.spinnerBusy.spinnerImage.height = 75;
        this.spinnerBusy.spinnerImage.width = 75;
    }

    private createPreviewImage() {
        this.imagePreview = new Image({
            id: "imageReportPreview",
            imageType: ImageType.PDF,
            fillHeight: true,
            fillRow: true,
        });
    }

    private sync() {
        if (this.searching === true)
            this.displaySingleComponentInViewerPanel(this.spinnerBusy);
        else if (StringUtil.isEmptyString(this.imagePreview.imageBytes) === true)
            this.displaySingleComponentInViewerPanel(this.labelPlaceholder);
        else
            this.displaySingleComponentInViewerPanel(this.imagePreview);
    }

    private displaySingleComponentInViewerPanel(component: Component) {
        if (this.components.length === 1 && component === this.components[0])
            return;
        this.removeAll();
        this.add(component);
    }
}
